import {
  IEsgGreenhouseMasterDataFormValues,
  ISubcommitteesFormValues,
} from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { SubcommitteeType } from 'src/Enum/EsgGreenhouse';

export const DEFAULT_CHECKED_SUBCOMMITTEE_VALUE = {
  infoCategoryMasterDataId: 825,
  nameTh: 'การกำกับดูแลด้านการเปลี่ยนแปลงสภาพภูมิอากาศ',
  nameEn: 'Climate Change Governance',
};

export const OTHER_SUBCOMMITTEE_MASTER_DATA = {
  infoCategoryMasterDataId: 832,
  nameEn: 'Other',
  nameTh: 'อื่น ๆ',
};

export const subcommitteeList = [
  {
    subcommitteeType: SubcommitteeType.AUDIT_COMMITTEE,
    nameEn: 'Audit Committee',
    nameTh: 'คณะกรรมการตรวจสอบ',
  },
  {
    subcommitteeType: SubcommitteeType.EXECUTIVE_COMMITTEE,
    nameEn: 'Executive Committee',
    nameTh: 'คณะกรรมการบริหาร',
  },
  {
    subcommitteeType: SubcommitteeType.OTHER_SUBCOMMITTEE,
    nameEn: 'Other Subcommittee',
    nameTh: 'สร้างใหม่',
  },
];

export const sortByOthersAtBottom = (
  list: IEsgGreenhouseMasterDataFormValues[]
): IEsgGreenhouseMasterDataFormValues[] =>
  [...list].sort((prev, current) =>
    prev.nameEn === 'Other' ? 1 : current.nameEn === 'Other' ? -1 : 0
  );

export const hasOtherSubcommitteeRoles = (
  list: IEsgGreenhouseMasterDataFormValues[]
): boolean =>
  list.some(
    (subCommitteeRole: IEsgGreenhouseMasterDataFormValues) =>
      subCommitteeRole?.nameEn === 'Other'
  );

export const mapSubcommitteeFormValuesToPayload = (
  data: ISubcommitteesFormValues
) => {
  return {
    ...data,
    id: data.id ?? undefined,
    subcommitteeType: data.subcommitteeType ?? '',
    subcommitteeRoles: (data.subcommitteeRoles || []).map((role) => ({
      infoCategoryMasterDataId: role.infoCategoryMasterDataId ?? role.id,
      nameTh: role.nameTh,
      nameEn: role.nameEn,
    })) as IEsgGreenhouseMasterDataFormValues[],
    otherSubcommitteeRoles: (data.otherSubcommitteeRoles || []).map((role) => ({
      nameTh: role.nameTh,
      nameEn: role.nameEn,
    })),
  };
};

export const mapSubcommitteeFormValues = (data: ISubcommitteesFormValues) => {
  return {
    ...data,
    id: data.id ?? undefined,
    subcommitteeType: data.subcommitteeType ?? '',
  };
};
